import { Id, Identifiable, Planzone, ProjectPortfolio } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type PersistedPortfolio = Identifiable<Omit<ProjectPortfolio, "projects">> & {
  projects: Id[];
};

function extractProjectPortfolios(
  planzone: Identifiable<Planzone>,
): PersistedPortfolio[] {
  return planzone.data && !!planzone.data.projectPortfolios
    ? JSON.parse(planzone.data.projectPortfolios)
    : [];
}

function portfoliosToString(portfolios: PersistedPortfolio[]) {
  return JSON.stringify(portfolios);
}

function generateUuid() {
  return `${Math.random().toString(16).slice(2)}-${Math.random()
    .toString(16)
    .slice(2)}-${Math.random().toString(16).slice(2)}-${Math.random()
    .toString(16)
    .slice(2)}`;
}

function saveProjectPortfolio(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>, portfolio: ProjectPortfolio) => {
    const savedPortfolio: Identifiable<ProjectPortfolio> = {
      ...portfolio,
      uuid: generateUuid(),
    };

    return httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${planzone.uuid}`,
        method: HttpMethods.GET,
      })
      .then((planzone) =>
        httpClient
          .sendHttpRequest({
            endpoint: `/planzones/${planzone.uuid}`,
            method: HttpMethods.PATCH,
            data: {
              data: {
                projectPortfolios: portfoliosToString([
                  {
                    ...savedPortfolio,
                    projects: savedPortfolio.projects.map(({ uuid }) => uuid),
                  },
                  ...extractProjectPortfolios(planzone),
                ]),
              },
            },
          })
          .then(() => savedPortfolio),
      );
  };
}

export { saveProjectPortfolio };
